<template>
  <v-card flat>
    <v-card-text>
      <v-layout row>
        <v-flex xs2>
          <v-text-field prefix="#" label="Alert (in Days)" disabled v-model="alertDuration"></v-text-field>
        </v-flex>

        <v-flex xs2>
          <v-text-field prefix="#" label="Invoice Id" disabled v-model="invoiceId"></v-text-field>
        </v-flex>

        <v-flex xs2>
          <v-menu
            :close-on-content-click="false"
            v-model="datepicker2"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            disabled
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="prevInvoiceDate"
              label="Invoice Date"
              prepend-icon="event"
              readonly
              disabled
            ></v-text-field>
            <v-date-picker v-model="prevInvoiceDate" disabled @input="datepicker2 = false"></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs2>
          <v-text-field
            prefix="#"
            :label="isBuyer? 'Credit Note Number' : 'Debit Note Number'"
            v-model="noteNumber"
          ></v-text-field>
        </v-flex>

        <v-flex xs2>
          <v-menu
            :close-on-content-click="false"
            v-model="datepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="invoiceDate"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="invoiceDate" @input="datepicker = false"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-tabs v-model="tab" background-color="deep-purple accent-4" centered dark icons-and-text>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        Return Invoice
        <v-icon>mdi-tumblr-reblog</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        New Invoice
        <v-icon>mdi-refresh</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="'tab-1-key'" :value="'tab-1'">
        <v-card flat>
          <v-card-text>
            <v-data-table :headers="headers" :items="items" hide-actions class="elevation-1">
              <template slot="items" slot-scope="props">
                <td class="justify-center layout px-0">
                  <v-btn icon class="mx-0" @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">{{ props.item.productName }}</td>
                <td class="text-xs-left">{{ props.item.HSN_code }}</td>
                <td>{{ props.item.taxableGST_rate }}</td>
                <td>{{ props.item.rate }}</td>
                <td>{{ props.item.unit }}</td>
                <td>{{ props.item.quantity }}</td>
                <td>{{ props.item.basicPrice }}</td>
                <td>{{ props.item.GSTValue }}</td>
                <td>{{ props.item.totlePrice }}</td>
                <td>{{props.item.CGST_val}} ₹ ({{props.item.CGST}} %)</td>
                <td>{{props.item.SGST_val}} ₹ ({{props.item.SGST}} %)</td>
                <td>{{props.item.IGST_val}} ₹ ({{props.item.IGST}} %)</td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
            <v-layout row>
              <v-flex xs1>
                <v-text-field label="Total Item" disabled :value="totalItems"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-select
                  dense
                  :readonly="isSummary"
                  :items="[{
              text: 'Cash',
              value: 'Cash'
            }, {
              text: 'Bank Account',
              value: 'Bank Account'
            }, {
              text: 'Cash & Bank Account',
              value: 'CashAndBank Account'
            }]"
                  label="Select Payment Type"
                  disabled
                  @change="resetAmounts()"
                  v-model="paymentType"
                ></v-select>
              </v-flex>
              <v-flex xs3>
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  disabled
                  v-model="selectedFirm"
                ></v-select>
              </v-flex>

              <v-flex xs3>
                <v-select
                  dense
                  :items="banksByFirms"
                  label="Select Bank"
                  v-model="selectedBank"
                  disabled
                ></v-select>
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  type="number"
                  label="Available Balance (in ₹)"
                  disabled
                  :value="availableBalance"
                ></v-text-field>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout row>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)"
                  type="number"
                  label="Total GST"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="GST_Val_total.SGST_val"
                  type="number"
                  label="Total SGST"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="GST_Val_total.CGST_val"
                  type="number"
                  label="Total CGST"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="GST_Val_total.IGST_val"
                  type="number"
                  label="Total IGST"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="GST_Percentage_total.GST_0"
                  type="number"
                  label="Total GST(0%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="GST_Percentage_total.GST_5"
                  type="number"
                  label="Total GST(5%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="GST_Percentage_total.GST_12"
                  type="number"
                  label="Total GST(12%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="GST_Percentage_total.GST_18"
                  type="number"
                  label="Total GST(18%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="GST_Percentage_total.GST_28"
                  type="number"
                  label="Total GST(28%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="(Number.parseFloat(totalAmount) - (Number.parseFloat(GST_Val_total.SGST_val) + Number.parseFloat(GST_Val_total.CGST_val) + Number.parseFloat(GST_Val_total.IGST_val)))"
                  type="number"
                  label="Basic Amount (in ₹)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                  dense
                  disabled
                  :items="[{
              text: 'Debit',
              value: 'Debit'
            }, {
              text: 'Partial Paid',
              value: 'Partial Paid'
            }, {
              text: 'Credit',
              value: 'Credit'
            }]"
                  label="Select Transaction type"
                  @change="resetAmounts()"
                  v-model="transactionType"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  type="number"
                  disabled
                  label="Discount (in ₹)"
                  v-model="discountAmount"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                  v-model="amountFromCash"
                  type="number"
                  disabled
                  label="Amount from Cash"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="isSummary"
                  v-model="amountFromBank"
                  type="number"
                  disabled
                  label="Amount from Bank"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  label="Paid Amount (in ₹)"
                  disabled
                  v-model="paidAmount"
                  prefix
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  label="Remaining Amount (in ₹)"
                  disabled
                  v-model="remainingAmount"
                  prefix
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  label="Total Amount (in ₹)"
                  disabled
                  :value="totalAmount"
                  prefix
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item :key="'tab-2-key'" :value="'tab-2'">
        <v-card flat>
          <v-card-text>
            <v-data-table :headers="headers" :items="returnItems" hide-actions class="elevation-1">
              <template slot="items" slot-scope="props">
                <td class="justify-center layout px-0">
                  <v-btn icon class="mx-0" disabled @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" disabled @click="deleteItem(props.item)">
                    <v-icon color="pink">delete</v-icon>
                  </v-btn>
                </td>
                <td class="text-xs-left">{{ props.item.productName }}</td>
                <td class="text-xs-left">{{ props.item.HSN_code }}</td>
                <td>{{ props.item.taxableGST_rate }}</td>
                <td>{{ props.item.rate }}</td>
                <td>{{ props.item.unit }}</td>
                <td>{{ props.item.quantity }}</td>
                <td>{{ props.item.basicPrice }}</td>
                <td>{{ props.item.GSTValue }}</td>
                <td>{{ props.item.totlePrice }}</td>
                <td>{{props.item.CGST_val}} ₹ ({{props.item.CGST}} %)</td>
                <td>{{props.item.SGST_val}} ₹ ({{props.item.SGST}} %)</td>
                <td>{{props.item.IGST_val}} ₹ ({{props.item.IGST}} %)</td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
            <v-layout row>
              <v-flex xs1>
                <v-text-field label="Total Item" disabled :value="totalItemsRetuen"></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-select
                  dense
                  :items="[{
                    text: 'Cash',
                    value: 'Cash'
                  }, {
                    text: 'Bank Account',
                    value: 'Bank Account'
                  }, {
                    text: 'Cash & Bank Account',
                    value: 'CashAndBank Account'
                  }]"
                  label="Select Payment Type"
                  disabled
                  @change="resetAmounts()"
                  v-model="paymentType"
                ></v-select>
              </v-flex>
              <v-flex xs3>
                <v-select
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  disabled
                  v-model="selectedFirm"
                ></v-select>
              </v-flex>

              <v-flex xs3>
                <v-select
                  dense
                  :items="banksByFirms"
                  label="Select Bank"
                  v-model="selectedBank"
                  disabled
                ></v-select>
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  type="number"
                  label="Available Balance (in ₹)"
                  disabled
                  :value="availableBalance"
                ></v-text-field>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout row>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="Number.parseFloat(R_GST_Val_total.SGST_val) + Number.parseFloat(R_GST_Val_total.CGST_val) + Number.parseFloat(R_GST_Val_total.IGST_val)"
                  type="number"
                  label="Total GST"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="R_GST_Val_total.SGST_val"
                  type="number"
                  label="Total SGST"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="R_GST_Val_total.CGST_val"
                  type="number"
                  label="Total CGST"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  disabled
                  :value="R_GST_Val_total.IGST_val"
                  type="number"
                  label="Total IGST"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="R_GST_Percentage_total.GST_0"
                  type="number"
                  label="Total GST(0%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="R_GST_Percentage_total.GST_5"
                  type="number"
                  label="Total GST(5%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="R_GST_Percentage_total.GST_12"
                  type="number"
                  label="Total GST(12%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="R_GST_Percentage_total.GST_18"
                  type="number"
                  label="Total GST(18%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="R_GST_Percentage_total.GST_28"
                  type="number"
                  label="Total GST(28%)"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  disabled
                  :value="(Number.parseFloat(totalAmountReturn) - (Number.parseFloat(R_GST_Val_total.SGST_val) + Number.parseFloat(R_GST_Val_total.CGST_val) + Number.parseFloat(R_GST_Val_total.IGST_val)))"
                  type="number"
                  label="Basic Amount (in ₹)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                  dense
                  disabled
                  :items="[{
              text: 'Debit',
              value: 'Debit'
            }, {
              text: 'Partial Paid',
              value: 'Partial Paid'
            }, {
              text: 'Credit',
              value: 'Credit'
            }]"
                  label="Select Transaction type"
                  @change="resetAmounts()"
                  v-model="transactionType"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  type="number"
                  disabled
                  label="Discount (in ₹)"
                  v-model="discountAmount"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                  v-model="amountFromCashReturn"
                  type="number"
                  disabled
                  label="Amount from Cash"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="isSummary"
                  v-model="amountFromBankReturn"
                  type="number"
                  disabled
                  label="Amount from Bank"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  label="Paid Amount (in ₹)"
                  disabled
                  v-model="paidAmountReturn"
                  prefix
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  label="Remaining Amount (in ₹)"
                  disabled
                  v-model="remainingAmountReturn"
                  prefix
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  type="number"
                  label="Total Amount (in ₹)"
                  disabled
                  :value="totalAmountReturn"
                  prefix
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
     <v-card-actions>
      <!-- <v-btn flat @click="resetForm">Reset</v-btn> -->
      <v-dialog v-model="dialog" max-width="800px">
        <add-item 
          :editedItem="editedItem" 
          :buyerId="buyerId"
          @closeAddItem="close" @saveAddItem="save"/>
      </v-dialog>
      <v-spacer></v-spacer>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click.native="saveInvoice()" color="primary">Update Invoice</v-btn>
    </v-card-actions>
  </v-card>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
import AddItem from "./UpdateItem";
import { getGSTPercentageTotal } from "../../../utils/";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];

export default {
  components: {
    AddItem
  },
  props: {
    isSummary: {
      type: Boolean,
      default: false
    },
    invoiceData: {
      type: Object,
      default: function() {
        return {
          items: [],
          rate: 2,
          totalAmount: 0,
          buyerId: null
        };
      }
    },
    returnInvoiceData: {
      type: Object,
      default: function() {
        return {
          items: [],
          rate: 2,
          totalAmount: 0,
          buyerId: null
        };
      }
    },
    buyerId: String,
    firms : {
      type: Array
    },
    banks : {
      type: Array
    },
    buyers : {
      type: Array
    },
    sellers : {
      type: Array
    },
  },
  data() {
    return {
      tab: null,
      isBuyer: null,
      formIsValid: true,
      dialog: false,
      headers: [
        { text: "", value: "name", sortable: false },
        { text: "Name", sortable: false, value: "productName" },
        { text: "HSN code", sortable: false, value: "HSN_code" },
        { text: "GST", sortable: false, value: "taxableGST_rate" },
        { text: "Rate", sortable: false, value: "rate" },
        { text: "Unit", sortable: false, value: "unit" },
        { text: "Quantity", sortable: false, value: "quantity" },
        { text: "Basic Price", sortable: false, value: "basicPrice" },
        { text: "GST value", sortable: false, value: "GSTValue" },
        { text: "Total Price", sortable: false, value: "totlePrice" },
        { text: "CGST value ( %)", sortable: false, value: "CGST" },
        { text: "SGST value ( %)", sortable: false, value: "SGST" },
        { text: "IGST value ( %)", sortable: false, value: "IGST" }
      ],
      items: this.invoiceData.items || [],
      returnItems: this.returnInvoiceData.items || [],
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0
      },
      amountFromCash: this.invoiceData.amountFromCash || 0,
      amountFromBank: this.invoiceData.amountFromBank || 0,

      amountFromCashReturn: this.returnInvoiceData.amountFromCash || 0,
      amountFromBankReturn: this.returnInvoiceData.amountFromBank || 0,

      alertDuration: this.invoiceData.duration || 0,
      paymentType: this.invoiceData.paymentType || "Cash",
      selectedFirm: this.invoiceData.firm || "",
      selectedBank: this.invoiceData.bank || "",
      prevInvoiceDate: this.invoiceData.date
        ? new Date(this.invoiceData.date).toISOString().substr(0, 10)
        : new Date().toISOString().substr(0, 10),
      invoiceDate: new Date().toISOString().substr(0, 10),

      datepicker: false,
      datepicker2: false,
      totalAmount: this.invoiceData.totalAmount || 0,
      paidAmount: this.invoiceData.paidAmount || 0,
      remainingAmount: this.invoiceData.remainingAmount || 0,

      totalAmountReturn: this.returnInvoiceData.totalAmount || 0,
      paidAmountReturn: this.returnInvoiceData.paidAmount || 0,
      remainingAmountReturn: this.returnInvoiceData.remainingAmount || 0,

      discountAmount: this.invoiceData.discountAmount || 0,
      invoiceDraft: {},
      returnInvoiceDraft: {},
      availableBalance: 0,
      firms: [],
      banks: [],
      transactionType: this.invoiceData.transactionType || "",
      amountFromCashDisabled: false,
      amountFromBankDisabled: false,
      status: this.invoiceData.status,
      gstType: this.invoiceData.gstType,
      currentUser: {},
      invoiceId: this.invoiceData.invoiceId,
      noteNumber: null,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      },
      R_GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      R_GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      }
    };
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    ...mapBuyerGetters(["selectedBuyer"]),
    firmsByBrand() {
      return this.firms
        .filter(item => item["brand"] === this.selectedBrand)
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    banksByFirms() {
      return this.banks
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.selectedFirm
          );
        })
        .map(item => {
          return {
            text: item["bankName"],
            value: item[".key"]
          };
        });
    },
    totalItems() {
      return this.items.length || 0;
    },
    totalItemsRetuen() {
      return this.returnItems.length || 0;
    },
    todaysDate() {
      let date = new Date();
      return `${date.getDate()}\\${date.getMonth()}\\${date.getYear()}`;
    },
    principalValueTotal() {
      return this.items.reduce(
        (accumulator, currentValue) =>
          accumulator + Number.parseFloat(currentValue.totlePrice),
        0
      );
    },
    principalValueTotalReturn() {
      return this.returnItems.reduce(
        (accumulator, currentValue) =>
          accumulator + Number.parseFloat(currentValue.totlePrice),
        0
      );
    }
  },
  mounted() {
    this.getCurrentUser();
  },
  created() {
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      buyerId: this.buyerId,
      brand: this.selectedBrand,
      date: new Date().getTime(),
      invoiceDate: new Date(this.invoiceDate).getTime(),
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? "0" : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId
    };
    this.returnInvoiceDraft = {
      items: JSON.parse(JSON.stringify(this.returnItems)),
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      buyerId: this.buyerId,
      brand: this.selectedBrand,
      date: new Date().getTime(),
      invoiceDate: new Date(this.invoiceDate).getTime(),
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? "0" : this.selectedBank,
      totalAmount: this.principalValueTotalReturn || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId
    };
    this.invoiceDraft[".key"] = this.invoiceData[".key"];
    this.returnInvoiceDraft[".key"] = this.invoiceData[".key"];
    this.calculateGSTType();
    this.getFirmAndBankBalance();
  },
  watch: {
    invoiceData: {
      handler(newVal, oldVal) {
        (this.items = newVal.items || []),
          (this.alertDuration = newVal.duration || 0);
        this.paymentType = newVal.paymentType || "cash";
        (this.amountFromCash = newVal.amountFromCash || 0),
          (this.amountFromBank = newVal.amountFromBank || 0),
          (this.transactionType = newVal.transactionType || ""),
          (this.rate = newVal.rate || 2);
        this.invoiceDate = newVal.date
          ? new Date(newVal.date).toISOString().substr(0, 10)
          : new Date().toISOString().substr(0, 10);
        this.selectedFirm = newVal.firm || 0;
        this.selectedBank = newVal.bank || 0;
        (this.totalAmount = newVal.totalAmount || 0),
          (this.paidAmount = newVal.paidAmount || 0),
          (this.remainingAmount = newVal.remainingAmount || 0),
          (this.discountAmount = newVal.discountAmount || 0);
        (this.status = newVal.status || ""),
          (this.gstType = newVal.gstType || ""),
          (this.invoiceId = newVal.invoiceId || "");
      },
      deep: true
    },
    returnInvoiceData: {
      handler(newVal, oldVal) {
        (this.returnItems = newVal.items || []),
          (this.alertDuration = newVal.duration || 0);
        this.paymentType = newVal.paymentType || "cash";
        (this.amountFromCashReturn = newVal.amountFromCash || 0),
          (this.amountFromBankReturn = newVal.amountFromBank || 0),
          (this.transactionType = newVal.transactionType || ""),
          (this.rate = newVal.rate || 2);
        this.invoiceDate = newVal.date
          ? new Date(newVal.date).toISOString().substr(0, 10)
          : new Date().toISOString().substr(0, 10);
        this.selectedFirm = newVal.firm || 0;
        this.selectedBank = newVal.bank || 0;
        (this.totalAmountReturn = newVal.totalAmount || 0),
          (this.paidAmountReturn = newVal.paidAmount || 0),
          (this.remainingAmountReturn = newVal.remainingAmount || 0),
          (this.discountAmount = newVal.discountAmount || 0);
        (this.status = newVal.status || ""),
          (this.gstType = newVal.gstType || ""),
          (this.invoiceId = newVal.invoiceId || "");
      },
      deep: true
    },
    items: {
      handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },
      deep: true
    },
    returnItems: {
      handler(newVal, oldVal) {
        this.updateAndEmitReturn("totalAmount", this.principalValueTotalReturn);
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },
      deep: true
    },
    selectedBrand(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brand", newVal);
        this.updateAndEmitReturn("brand", newVal);
      }
    },
    status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
        this.updateAndEmitReturn("status", newVal);
      }
    },
    gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
        this.updateAndEmitReturn("gstType", newVal);
      }
    },
    noteNumber(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("noteNumber", newVal);
        this.updateAndEmitReturn("noteNumber", newVal);
      }
    },
    buyerId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("buyerId", newVal);
        this.updateAndEmitReturn("buyerId", newVal);
      }
    },
    alertDuration(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("duration", Number.parseInt(newVal));
        this.updateAndEmitReturn("duration", Number.parseInt(newVal));
      }
    },
    paymentType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("paymentType", newVal);
        this.updateAndEmitReturn("paymentType", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
        this.calculateTotal();
      }
    },
    transactionType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transactionType", newVal);
        this.updateAndEmitReturn("transactionType", newVal);
        switch (newVal) {
          case "Debit": {
            this.updateAndEmit("status", "due");
            this.updateAndEmitReturn("status", "due");
            break;
          }
          case "Partial Paid": {
            this.updateAndEmit("status", "partial");
            this.updateAndEmitReturn("status", "due");
            break;
          }
          case "Credit": {
            this.updateAndEmit("status", "paid");
            this.updateAndEmitReturn("status", "due");
            break;
          }
        }
        this.calculateTotal();
      }
    },
    invoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("date", new Date(newVal).getTime());
        this.updateAndEmitReturn("date", new Date(newVal).getTime());
      }
    },
    prevInvoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("parentInvoiceDate", new Date(newVal).getTime());
        this.updateAndEmitReturn("parentInvoiceDate", new Date(newVal).getTime());
      }
    },
    invoiceId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("invoiceId", newVal);
        this.updateAndEmitReturn("invoiceId", newVal);
      }
    },
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("firm", newVal);
        this.updateAndEmitReturn("firm", newVal);
        this.getFirmAndBankBalance();
        this.calculateGSTType();
      }
    },
    selectedBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("bank", newVal);
        this.updateAndEmitReturn("bank", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
      }
    },
    amountFromCash(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal();
      }
    },
    amountFromBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal();
      }
    },
    discountAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("discountAmount", newVal);
        this.updateAndEmitReturn("discountAmount", newVal);
        this.calculateTotal();
      }
    }
  },
  methods: {
    resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;

      this.amountFromCashReturn = 0;
      this.amountFromBankReturn = 0;
    },
    getFirmAndBankBalance() {
      switch (this.paymentType) {
        case "Cash": {
          if (this.selectedFirm) {
            let selectedFirm = this.firms.filter(
              item =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.selectedFirm
            );
            this.availableBalance =
              selectedFirm.length &&
              (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "Bank Account": {
          if (this.selectedBank) {
            let selectedBank = this.banks.filter(
              item =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.selectedBank
            );
            this.availableBalance =
              selectedBank.length &&
              (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
        case "CashAndBank Account": {
          if (this.selectedFirm && this.selectedBank) {
            let selectedFirm = this.firms.filter(
              item =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.selectedFirm
            );
            let selectedBank = this.banks.filter(
              item =>
                item["brand"] === this.selectedBrand &&
                item[".key"] == this.selectedBank
            );
            this.availableBalance =
              selectedFirm.length &&
              selectedBank.length &&
              (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0) +
                (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
          } else {
            this.availableBalance = 0;
          }
          break;
        }
      }
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.items.splice(index, 1);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    calculateTotal() {
      let discountAmount = Number.parseFloat(this.discountAmount).toFixed(2);
      let amountFromBank = Number.parseFloat(this.amountFromBank).toFixed(2);
      let amountFromCash = Number.parseFloat(this.amountFromCash).toFixed(2);

      let amountFromBankReturn = Number.parseFloat(
        this.amountFromBankReturn
      ).toFixed(2);
      let amountFromCashReturn = Number.parseFloat(
        this.amountFromCashReturn
      ).toFixed(2);
      switch (this.paymentType) {
        case "Cash": {
          this.amountFromBank = 0;
          this.amountFromBankReturn = 0;
          this.amountFromBankDisabled = true;
          switch (this.transactionType) {
            case "Debit": {
              this.amountFromCashDisabled = true;
              this.amountFromCash = this.totalAmount - discountAmount;
              this.remainingAmount = this.totalAmount - discountAmount;
              this.amountFromCashReturn =
                this.totalAmountReturn - discountAmount;
              this.remainingAmountReturn =
                this.totalAmountReturn - discountAmount;
              this.paidAmount = 0;
              break;
            }
            case "Partial Paid": {
              this.amountFromCashDisabled = false;
              this.remainingAmount =
                Number.parseFloat(this.totalAmount) -
                Number.parseFloat(amountFromCash + discountAmount);
              this.paidAmount = amountFromCash;

              this.remainingAmountReturn =
                Number.parseFloat(this.totalAmountReturn) -
                Number.parseFloat(amountFromCashReturn + discountAmount);
              this.paidAmountReturn = amountFromCashReturn;
              break;
            }
            case "Credit": {
              this.amountFromCashDisabled = true;
              this.amountFromCash = this.totalAmount - discountAmount;
              this.remainingAmount = 0;
              this.paidAmount = this.totalAmount - discountAmount;

              this.amountFromCashReturn =
                this.totalAmountReturn - discountAmount;
              this.remainingAmountReturn = 0;
              this.paidAmountReturn = this.totalAmountReturn - discountAmount;
              break;
            }
          }
          break;
        }
        case "Bank Account": {
          this.amountFromCashDisabled = true;
          this.amountFromCash = 0;
          this.amountFromCashReturn = 0;
          switch (this.transactionType) {
            case "Debit": {
              this.amountFromBankDisabled = true;
              this.amountFromBank = this.totalAmount - discountAmount;
              this.remainingAmount = this.totalAmount - discountAmount;
              this.paidAmount = 0;

              this.amountFromBankReturn =
                this.totalAmountReturn - discountAmount;
              this.remainingAmountReturn =
                this.totalAmountReturn - discountAmount;
              this.paidAmountReturn = 0;
              break;
            }
            case "Partial Paid": {
              this.amountFromBankDisabled = false;
              this.remainingAmount =
                this.totalAmount -
                Number.parseFloat(amountFromBank + discountAmount);
              this.paidAmount = amountFromBank;

              this.remainingAmountReturn =
                this.totalAmountReturn -
                Number.parseFloat(amountFromBankReturn + discountAmount);
              this.paidAmountReturn = amountFromBankReturn;
              break;
            }
            case "Credit": {
              this.amountFromBankDisabled = true;
              this.amountFromBank = this.totalAmount - discountAmount;
              this.remainingAmount = 0;
              this.paidAmount = this.totalAmount - discountAmount;

              this.amountFromBankReturn =
                this.totalAmountReturn - discountAmount;
              this.remainingAmountReturn = 0;
              this.paidAmountReturn = this.totalAmountReturn - discountAmount;
              break;
            }
          }
          break;
        }
        case "CashAndBank Account": {
          this.amountFromCashDisabled = false;
          this.amountFromBankDisabled = false;
          let totalBankAndCash = amountFromCash + amountFromBank;
          let totalBankAndCashReturn =
            amountFromCashReturn + amountFromBankReturn;
          switch (this.transactionType) {
            case "Debit": {
              this.remainingAmount = this.totalAmount - discountAmount;
              this.paidAmount = 0;

              this.remainingAmountReturn =
                this.totalAmountReturn - discountAmount;
              this.paidAmountReturn = 0;
              break;
            }
            case "Partial Paid": {
              this.paidAmount = totalBankAndCash;
              this.remainingAmount =
                this.totalAmount -
                Number.parseFloat(this.paidAmount + discountAmount);

              this.paidAmountReturn = totalBankAndCashReturn;
              this.remainingAmountReturn =
                this.totalAmountReturn -
                Number.parseFloat(this.paidAmountReturn + discountAmount);
              break;
            }
            case "Credit": {
              this.remainingAmount = 0;
              this.paidAmount = this.totalAmount - discountAmount;

              this.remainingAmountReturn = 0;
              this.paidAmountReturn = this.totalAmountReturn - discountAmount;
              break;
            }
          }
          break;
          break;
        }
      }
      this.updateAndEmit("paidAmount", this.paidAmount);
      this.updateAndEmit("amountFromCash", this.amountFromCash);
      this.updateAndEmit("amountFromBank", this.amountFromBank);
      this.updateAndEmit("remainingAmount", this.remainingAmount);

      this.updateAndEmitReturn("paidAmount", this.paidAmountReturn);
      this.updateAndEmitReturn("amountFromCash", this.amountFromCashReturn);
      this.updateAndEmitReturn("amountFromBank", this.amountFromBankReturn);
      this.updateAndEmitReturn("remainingAmount", this.remainingAmountReturn);
    },
    save(editedItem, returnItem) {
      if (this.editedIndex > -1) {
        Object.assign(this.items[this.editedIndex], editedItem);
        Object.assign(this.returnItems[this.editedIndex], returnItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateTotal();
      this.calculateGSTType();
      this.close();
    },
    calculateGSTType() {
      if (Object.keys(this.currentUser).length === 0) {
        this.getCurrentUser();
      }
      this.GST_Val_total.SGST_val = 0;
      this.GST_Val_total.CGST_val = 0;
      this.GST_Val_total.IGST_val = 0;

      this.R_GST_Val_total.SGST_val = 0;
      this.R_GST_Val_total.CGST_val = 0;
      this.R_GST_Val_total.IGST_val = 0;
      this.items.map((item, index) => {
        let GST = item["taxableGST_rate"];
        let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0]
        if (
          this.selectedFirm &&
          this.currentUser.state &&
          Number.parseFloat(GST) &&
          firm.state === this.currentUser.state
        ) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.updateAndEmit("gstType", "SGST|CGST");
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          this.GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.updateAndEmit("gstType", "IGST");
        }
        this.items[index] = item;
      });

      this.returnItems.map((item, index) => {
        let GST = item["taxableGST_rate"];
        let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0]
        if (
          this.selectedFirm &&
          this.currentUser.state &&
          Number.parseFloat(GST) &&
          firm.state === this.currentUser.state
        ) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          this.R_GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.R_GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.R_GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.updateAndEmitReturn("gstType", "SGST|CGST");
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          this.R_GST_Val_total.SGST_val += Number.parseFloat(item["SGST_val"]);
          this.R_GST_Val_total.CGST_val += Number.parseFloat(item["CGST_val"]);
          this.R_GST_Val_total.IGST_val += Number.parseFloat(item["IGST_val"]);
          this.updateAndEmitReturn("gstType", "IGST");
        }
        this.returnItems[index] = item;
      });


      this.GST_Percentage_total = getGSTPercentageTotal(this.items);
      this.R_GST_Percentage_total = getGSTPercentageTotal(this.returnItems);
      this.updateAndEmit("items", this.items);
      this.updateAndEmitReturn("items", this.returnItems);
    },
    updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
      this.$emit("updateInvoiceData", this.invoiceDraft);
    },
    updateAndEmitReturn(key, value) {
      this.returnInvoiceDraft[key] = value;
      this.$emit("updateInvoiceReturnData", this.returnInvoiceDraft);
    },
    saveInvoice() {
      this.updateAndEmit("buyerId", this.selectedBuyer);
      //      this.manageUnchangedItems();
      this.$emit("close");
    },
    getCurrentUser() {
      let buyer =  this.buyers.filter(item => (item[".key"] === this.selectedBuyer))[0];
      let seller = this.sellers.filter(item => (item[".key"] === this.selectedBuyer))[0];
      this.isBuyer = !!buyer ? true : false;
      this.currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },
    manageUnchangedItems() {
      this.items.map((item, index) => {
        if (!item.changed) {
          this.items.splice(index, 1);
        }
      });
      this.calculateTotal();
      this.calculateGSTType();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Buyers/InvoiceReturn/InvoiceScreen.vue